module.exports = __webpack_public_path__ + "static/media/s_v10_t8_1.461921c4.mp3";